var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.4 24.4",
    style: {
      enableBackground: "new 0 0 24.4 24.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M20.6,3.8c-2.3-2.3-5.3-3.5-8.5-3.5C9,0.2,6,1.5,3.7,3.8c-4.7,4.7-4.7,12.3,0,16.9c2.3,2.3,5.3,3.5,8.5,3.5 c3.2,0,6.2-1.2,8.5-3.5c2.3-2.3,3.5-5.3,3.5-8.5C24.1,9,22.9,6,20.6,3.8z M13.2,20.2c-0.8,0.7-1.9,0.7-2.7,0.1 c-0.3-0.2-0.6-0.7-0.6-1.5c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,0.8-0.5,1.4-0.5c0.5,0,1,0.2,1.4,0.5c0.4,0.4,0.6,0.9,0.6,1.5 C13.9,19.4,13.7,19.8,13.2,20.2z M14.6,11.7L14.6,11.7c-0.4,0.4-1.3,1.2-1.3,2.1c0,0.8-0.6,1.4-1.4,1.4c-0.9,0-1.4-0.5-1.4-1.4 c0-1.5,0.7-2.8,2.1-4c0.9-0.8,1.2-1.2,1.2-1.8c0-0.9-0.7-1.5-1.8-1.5c-1.3,0-2.1,0.7-2.1,2c0,0.8-0.6,1.4-1.4,1.4 c-0.8,0-1.3-0.5-1.3-1.4c0-2.9,1.9-4.7,4.9-4.7c2.6,0,4.5,1.8,4.5,4.3C16.6,9.9,15.5,10.9,14.6,11.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/Interrogation.574dd3fd.svg";
export { ForwardRef as ReactComponent };